import e from"slugify";e.extend({".":"-"}),e.extend({"/":"-"}),e.extend({"\\":"-"}),e.extend({"%":""}),e.extend({"&":"-"});const t=(t="",n=!0)=>e(null!=t?t:"",{lower:n,replacement:"-",strict:!0});export{t as default};
